import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import ProductTable from '../components/ProductTable'
import { useDispatch } from 'react-redux'
import { fetchLoginUrl } from '../redux/slices/loginSlice'
import Layout from '../layout/Layout'

// Landing-Seite fuer einen B2B-Grosshaendler (z.B. eany).
// Nutzt dieselbe ProductTable wie eigene Listen, im supplierPrefix-Modus.
export default function SupplierScanner() {
  let dispatch = useDispatch()
  let { supplierPrefix } = useParams()

  useEffect(() => {
    dispatch(fetchLoginUrl())
  }, [dispatch])

  return (
    <Layout scrollWithHeader>
      <ProductTable supplierPrefix={supplierPrefix} />
    </Layout>
  )
}
